import { ReviewsList } from 'components/reviews/ReviewsList/ReviewsList'

export const ProfileReviews: React.FC = () => {
  return <ReviewsList isSellerView />
}
